module.exports = __webpack_public_path__ + "img/gi.4217c0d8.svg";